import React from 'react';
import { Outlet } from 'react-router-dom';

import './TopUpCard.scss';

const TopUpCard = () => {
	return (
		<div className='TopUpCard'>
			<Outlet />
		</div>
	);
};

export default TopUpCard;
